import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  StadiaMapsReverseGeocodingParams,
  StadiaMapsReverseGeocodingResponse,
  StadiaMapsTimezoneResponse,
} from './stadia-maps.types';
import { firstValueFrom, map, take } from 'rxjs';
import { STADIA_MAPS_SERVICE_API_KEY } from './stadia-maps.tokens';

@Injectable({ providedIn: 'root' })
export class StadiaMapsService {
  private httpClient = inject(HttpClient);
  private apiKey = inject(STADIA_MAPS_SERVICE_API_KEY);

  async reverseGeocode(params: StadiaMapsReverseGeocodingParams) {
    const apiUrl = 'https://api.stadiamaps.com/geocoding/v1/reverse';

    let httpParams = new HttpParams().appendAll({
      api_key: this.apiKey,
      'point.lat': params.latitude,
      'point.lon': params.longitude,
    });

    const request$ = this.httpClient
      .get<StadiaMapsReverseGeocodingResponse>(apiUrl, {
        params: httpParams,
      })
      .pipe(take(1));

    return firstValueFrom(request$);
  }

  async getTimezone(coordinates: {
    latitude: number;
    longitude: number;
  }): Promise<string | undefined> {
    const apiUrl = 'https://api.stadiamaps.com/tz/lookup/v1';

    let httpParams = new HttpParams().appendAll({
      api_key: this.apiKey,
      lat: coordinates.latitude,
      lng: coordinates.longitude,
    });

    const request$ = this.httpClient
      .get<StadiaMapsTimezoneResponse>(apiUrl, {
        params: httpParams,
      })
      .pipe(
        take(1),
        map(response => {
          return response?.tz_id;
        }),
      );

    return firstValueFrom(request$);
  }
}
